import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class ConfigService {

  constructor() {}

    config = {
      account: "orange",
      profile: "comm",
      environment: `${environment.production ? 'prod' : 'qa'}`
    };
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts